import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { useNavigate, Link } from 'react-router-dom';

const dummyWorkflow = [
  { step: "Request Submitted", date: "2025-09-18", remarks: "Initial submission" },
  { step: "Approved", date: "2025-09-19", remarks: "Approved by admin" },
  { step: "Information Required", date: "2025-09-20", remarks: "Additional info needed" },
  { step: "Not Approved", date: "2025-09-21", remarks: "Rejected due to missing docs" },
];

export default function SyntraMfgEnroll() {
  const location = useLocation();
  const selectedRole = location.state?.selectedRole || "";
  const [role, setRole] = useState(selectedRole);
  const [remarks, setRemarks] = useState("");

  return (
    <div className="min-h-screen bg-cyan-900 text-white p-6">
      <h2 className="text-2xl font-bold mb-4 text-yellow-300">SyntraMfg Enrollment</h2>

      {/* Role Selection */}
      <div className="mb-4">
        <label className="block mb-2 font-semibold text-cyan-100">Select Your Role</label>
        <select
          value={role}
          onChange={(e) => setRole(e.target.value)}
          className="w-full p-2 rounded bg-cyan-800 text-white h-10"
        >
          <option value="">-- Choose Role --</option>
          {[
             "🏭 Plant Regional Co-ordinator",
            "📍Area Co-ordinator",
            "🔗Cluster Co-ordinator",
            "⚙️ Manufacturer",
            "🏆Think5Whys Aggregator (Self Employment)",
            "👷‍♂️Factory Workers",
            "📦Raw Material Supplier",
            "🏬Distributor / Dealer",
            "🛒Retailer / Showroom",
            "🚚Logistics Provider",
            "📦Warehouse & Storage",
            "🌐Export-Import Partner",
            "🛠️OEM (Original Equipment Manufacturer)",
            "🔧Maintenance & Service Provider",
            "🤝Industry Association / NGO",
            "🏢Corporate / Enterprise Buyer",
            "📚Manufacturing Scholar / Researcher",
            "🤖Robotics & Automation Specialist",
            "🧑‍🔬Process Expert / Consultant",
            "📊Quality & Compliance Auditor",
          ].map((r, idx) => (
            <option key={idx} value={r}>{r}</option>
          ))}
        </select>
      </div>

      {/* Remarks Input */}
      <div className="mb-6">
        <label className="block mb-2 font-semibold text-cyan-100">Remarks</label>
        <textarea
          value={remarks}
          onChange={(e) => setRemarks(e.target.value)}
          placeholder="Enter your remarks..."
          className="w-full p-2 rounded bg-gray-100 text-black"
          style={{width: "100%", height: "250px"}}
        />
      </div>
      
      {/* Submit Button */}
      <button className="bg-yellow-400 text-black px-6 py-2 rounded hover:bg-yellow-500 font-semibold">
        Submit Enrollment
      </button>

      {/* Dummy Workflow */}
      <div className="mb-6">
        <h3 className="text-xl font-bold mb-3 text-yellow-300">Status</h3>
        <div className="space-y-4">
          {dummyWorkflow.map((item, idx) => (
            <div key={idx} className="bg-cyan-700 p-4 rounded shadow-md">
              <p className="font-semibold">{item.step}</p>
              <p className="text-sm text-cyan-200">Date: {item.date}</p>
              <p className="text-sm text-cyan-200">Remarks: {item.remarks}</p>
            </div>
          ))}
        </div>
      </div>
      {/* Footer */}
        <footer className="bg-cyan-700 text-white py-10 px-4 sm:px-6 md:px-20">
            <div className="flex flex-col md:flex-row justify-between items-center text-center md:text-left">
            <p className="text-sm">&copy; 2025 Think5Whys Global DeepTech Solutions. All rights reserved.</p>
            <div className="flex space-x-6 mt-4 md:mt-0 text-sm">
                <Link to="/about-us" className="text-white hover:text-cyan-400 transition">About</Link>
                <Link to="/privacy-policy" className="text-white hover:text-cyan-400 transition">Privacy Policy</Link>
                <Link to="/terms-of-use" className="text-white hover:text-cyan-400 transition">Terms of Use</Link>
                <Link to="/contact-us" className="text-white hover:text-cyan-400 transition">Contact</Link>
            </div>
            </div>
        </footer>
    </div>
  );
}
